import { render, staticRenderFns } from "./GatherPage.vue?vue&type=template&id=3f9d3b2d&scoped=true"
import script from "./GatherPage.vue?vue&type=script&lang=js"
export * from "./GatherPage.vue?vue&type=script&lang=js"
import style0 from "./GatherPage.vue?vue&type=style&index=0&id=3f9d3b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9d3b2d",
  null
  
)

export default component.exports